import React from 'react'
import PropTypes from 'prop-types'
import styles from '../menu.scss'

import { fullName as userFullName } from 'services/user_helpers'

import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import Button from 'src/components/common/Button'
import SvgIcon from 'components/common/SvgIcon'
import settingsIcon from 'assets/icons/icons8-settings.svg'
import piggyBankIcon from 'assets/icons/icons8-piggy-bank.svg'
import profileIcon from 'assets/icons/icons8-person.svg'
import documentIcon from 'assets/icons/icons8-document.svg'
import helpIcon from 'assets/icons/icons8-help.svg'
import openBookIcon from 'assets/icons/icons8-open-book.svg'
import lockIcon from 'assets/icons/icons8-lock.svg'
import copyrightIcon from 'assets/icons/icons8-copyright.svg'

export class ProfilePanel extends React.Component {
  render () {
    const { user } = this.props
    const userName = user ? userFullName(user) : ''

    return (
      <div className={styles['menu-panel']}>
        <h3 className={styles['menu-title']}>My Profile</h3>
        <div className={styles['menu-panel-content']}>
          <div className={styles['menu-avatar-name']}>
            <UserAvatarContainer user={this.props.user || {}} size={50} />
            <p>{userName}</p>
          </div>
          <div className={styles['invite-message']}>
            <div>
              <p>
                <span>
                  <strong>Free</strong>: 10/10 invites remaining mothly limit resets in 28 days.
                </span>
              </p>
            </div>
          </div>
          <Button onClick={() => { }} className={styles['button']}>SEE UPGRADE OPTIONS</Button>
          <div className={styles['line-breaker']} />
          <hr className={styles['hr']} />
          <div className={styles['list']}>
            <div className={styles['option']}>
              <SvgIcon icon={settingsIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>General Settings</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={piggyBankIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Get Free Invites🎉</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={profileIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Edit Profile</p>
            </div>
          </div>
          <hr className={styles['hr']} />
          <div className={styles['list']}>
            <div className={styles['option']}>
              <SvgIcon icon={documentIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>FAQ</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={helpIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Help</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={openBookIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Terms of Service</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={lockIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Privacy Policy</p>
            </div>
            <div className={styles['option']}>
              <SvgIcon icon={copyrightIcon} style={{ width: '30px', height: '30px', color: '#A6A6A6' }} />
              <p>Acknowledgement</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ProfilePanel.propTypes = {
  user: PropTypes.object
}

export default ProfilePanel



// WEBPACK FOOTER //
// ./src/components/menu/panels/ProfilePanel.jsx